export default "__VITE_ASSET__QPzBkVXI__"